import * as React from "react";

import Modal, { ModalSize } from "../../../../misc/components/modal";
import { SelectNewDateTime } from "./SelectNewDateTime";
import { WizardActionTypes, WizardState } from "../WizardTypings";
import { CorrectionPreviewModal } from "../../CorrectionPreviewModal";
import { VisibleWizards, Correction } from "../../../Request/DcfRequestReducer";
import { useWizard } from "../../../Hooks/UseWizard";
import { CorrectionTypesEnum } from "../../../../misc/api/apiTypes";

export interface RecordingStartCorrectionWizardProps {
    isVisible: boolean;
    sessionCurrentDateTime: string;
    savedCorrections?: Correction[];
    onClose: () => void;
    onComplete: (corrections: Correction[]) => void;
}

export const RecordingStartCorrectionWizard = ({
    isVisible,
    sessionCurrentDateTime,
    savedCorrections,
    onClose,
    onComplete
}: RecordingStartCorrectionWizardProps): JSX.Element => {
    const { currentState, dispatch } = useWizard();

    const savedDateTime = savedCorrections?.find(c => c.field === "RecordingStartDateTime")?.newValue;

    const [currentDateTime, setCurrentDateTime] = React.useState(
        savedDateTime || sessionCurrentDateTime
    );



    if (!isVisible) {
        return null;
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <SelectNewDateTime
                    originalDateTime={sessionCurrentDateTime}
                    dateTime={currentDateTime}
                    onChange={(v): void => setCurrentDateTime(v.toISOString(true))}
                    onNext={(): void => dispatch(WizardActionTypes.Next)}
                />
            );
            break;
        case 1:
            const corrections = [
                {
                    sourceCorrection: VisibleWizards.RecordingStart,
                    correctionTypeId: CorrectionTypesEnum.SubjectNumber,
                    entity: "CoughSession",
                    field: "RecordingStartDateTime",
                    oldValue: sessionCurrentDateTime,
                    newValue: currentDateTime
                }
            ];

            page = (
                <CorrectionPreviewModal
                    corrections={corrections}
                    miscCorrection={null}
                    onNext={(): void => {
                        dispatch(WizardActionTypes.Reset);
                        onComplete(corrections);
                    }}
                    onPrev={(): void => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal
            show={true}
            header="Change Recording Start"
            size={ModalSize.Large}
            closeModalHandler={onClose}
        >
            {page}
        </Modal>
    );
};
